import React, { useContext } from 'react'
import './Hero.sass'
import { withRouter } from 'react-router-dom'

import Icon from '../../ui/Icon/Icon'

import Button from '../../ui/Button/Button'
import heroBg from './assets/bg.jpg'
import hero from './assets/bgsir.jpg'
import { AuthContext } from '../../App'

function Hero() {
  const data = [
    { icon: 'shield-check', title: 'Гарантия и сервисная поддержка' },
    { icon: 'box-alt', title: 'Профессиональная сборка' },
    { icon: 'ruler', title: 'Бесплатный дизайн-замер' },
    { icon: 'shipping-fast', title: 'Бесплатная доставка' },
  ]

  const { contacts, setShowContactUs } = useContext(AuthContext)

  return (
    <div
      id="home"
      className="Site-Hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="HeroBg" style={{ backgroundImage: `url(${hero})` }}></div>
      <div className="DefaultContainer">
        <div className="Offer">
          <h1 className="Title">
            Сиріус захід - сталева репутація, лідерський підхід
          </h1>
          {/* <div className="Benefits">
            {data.map((d) => (
              <Benefit {...d} />
            ))}
          </div> */}
          <div className="Buttons">
            <Button
              theme="primary"
              title="Каталог послуг"
              type="navhashlink"
              icon="folder-open"
              iconWeight="solid"
              path="#cataloge"
              size={48}
            />
            <Button
              theme="secondary"
              title="Замовити дзвінок"
              icon="phone"
              iconWeight="solid"
              type="button"
              onClick={() =>
                setShowContactUs({
                  show: true,
                  title: 'Замовити дзвінок',
                  emailSubject: 'Запит на консультацію',
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

function Benefit({ icon, title }) {
  return (
    <div className="Benefit">
      <Icon name={icon} />
      <span>{title}</span>
    </div>
  )
}

export default withRouter(Hero)
